import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { getStates } from "../../service/Locations/locationsService";

interface StatesState {
  states: string[];
  loading: boolean;
  error: string | null;
  selectedState: string;
}

// Initial state
const initialState: StatesState = {
  states: [],
  loading: false,
  error: null,
  selectedState: "",
};

// Async thunk for fetching states
export const fetchStates = createAsyncThunk(
  "states/fetchStates",
  async (_, { getState, rejectWithValue }) => {
    const { states } = (getState() as { states: StatesState }).states;
    if (states.length > 0) {
      return states;
    }
    try {
      const response = await getStates();
      return response.data.data; // Extract states array
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch states");
    }
  }
);

// Redux Slice
const statesSlice = createSlice({
  name: "states",
  initialState,
  reducers: {
    setSelectedState: (state, action: PayloadAction<string>) => {
      console.log("Selected state:", action.payload);
      state.selectedState = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStates.fulfilled, (state, action: PayloadAction<string[]>) => {
        state.loading = false;
        state.states = action.payload;
      })
      .addCase(fetchStates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});
export const { setSelectedState } = statesSlice.actions;
export default statesSlice.reducer;
